import { Actions as SocketActions } from '../actions/socket'

const initialState = {
    isConnecting: false,
    isConnected: false,
    isDisconnecting: false,
}

export default (state = initialState, { type }) => {
    switch (type) {
        case SocketActions.SOCKET_CONNECTING: {
            return {
                ...state,
                isConnecting: true,
                isConnected: false,
            }
        }
        case SocketActions.SOCKET_CONNECTED: {
            return {
                ...state,
                isConnecting: false,
                isConnected: true,
            }
        }
        case SocketActions.SOCKET_DISCONNECTING: {
            return {
                ...state,
                isDisconnecting: true,
            }
        }
        case SocketActions.SOCKET_DISCONNECTED: {
            return {
                ...state,
                isConnecting: false,
                isConnected: false,
                isDisconnecting: false,
            }
        }
        default:
            return state
    }
}
